import * as logger from 'loglevel';
import axios from 'axios';

let translations = {};
let showKeysIfNotExistFlag = true;
let dangerouslyUseLabelsKey = false;
let specialLabelsToOmit = [];
let missingLabelKeys = [];

/**
 * Basic validations for the labels API response
 * @param {*} transl
 */
const validateTranslationsResponse = (transl) => {
  const validation = { isValid: true, message: '' };
  if (!transl || typeof transl !== 'object') {
    validation.isValid = false;
    return {
      isValid: false,
      data: transl,
      message: 'INTEGRATION__TRANSLATIONS: Translations must be an Array'
    };
  }
  return validation;
};

/**
 * Intent to retrieve labels from a given API
 * @param {*} airlineIataCode
 * @param {*} locale
 * @param {*} integrationSettings
 */
const getTranslations = (airlineIataCode, locale, integrationSettings, staticLabels) => {
  return new Promise((resolve, reject) => {
    if (!integrationSettings) {
      const MESSAGE = `INTEGRATION__TRANSLATIONS: **integrationSettings** not especified.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    }
    const { translations: translationsApi = {}, preloadData } = integrationSettings;
    showKeysIfNotExistFlag =
      typeof translationsApi.showLabelKeysIfNoValue !== 'undefined'
        ? translationsApi.showLabelKeysIfNoValue
        : showKeysIfNotExistFlag;

    if (translationsApi?.omitLabels !== undefined && translationsApi?.omitLabels.length > 0) {
      specialLabelsToOmit = translationsApi?.omitLabels;
    }

    dangerouslyUseLabelsKey = translationsApi.dangerouslyUseLabelsKey || false;
    if (staticLabels) {
      logger.info(`INTEGRATION__TRANSLATIONS: Using static defined labels`);
      translations = staticLabels;
      resolve(staticLabels);
      return;
    }

    // check if preloadData is passed
    if (preloadData && preloadData.labels) {
      logger.info(`INTEGRATION__TRANSLATIONS: Using preload data defined labels`);
      translations = preloadData.labels;
      resolve(preloadData.labels);
      return;
    }

    if (!airlineIataCode || !locale) {
      const MESSAGE = `INTEGRATION__TRANSLATIONS: **airlineIataCode** or **locale** not especified.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    }
    if (!translationsApi.method || !translationsApi.endPoint || !translationsApi.headers) {
      const MESSAGE = `INTEGRATION__TRANSLATIONS: **ENV.translations** configuration issues.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    }
    axios({
      method: translationsApi.method,
      url: `${translationsApi.endPoint}`,
      headers: translationsApi.headers,
      data: {
        airlineCode: airlineIataCode,
        language: locale,
        source: 'trfx-api'
      }
    })
      .then((response) => {
        const validation = validateTranslationsResponse(response.data);
        if (validation.isValid) {
          logger.info('INTEGRATION__TRANSLATIONS: Successful request', response.data);
          translations = response.data;
          resolve(response.data);
        } else {
          logger.error(validation.message, validation.data);
          reject(response.data);
        }
      })
      .catch((err) => {
        logger.error('INTEGRATION__TRANSLATIONS:', err);
        reject(new Error(`INTEGRATION__TRANSLATIONS: ${err}`));
      });
  });
};

/**
 * Given a key will retrieve the translations associated to it
 * @param {*} key
 * @param {*} defaultValue
 */
const translate = (key, defaultValue) => {
  const labelValue = translations[key];
  if (dangerouslyUseLabelsKey || showKeysIfNotExistFlag) {
    const omitLabels = [
      /day-long-\w+$/gi,
      /day-short-\w+$/gi,
      /day-min-\w+$/gi,
      /day-one-letter-\w+$/gi,
      /cmp-locale-day-js-\w+$/gi,
      /month-\w+$/gi,
      /month-short-\w+$/gi,
      /month-min-\w+$/gi,
      /cmp-currency-.+$/gi,
      ...specialLabelsToOmit
    ];
    let labelFound = false;
    omitLabels.forEach((item) => {
      if (key && key.match(item)) {
        labelFound = true;
      }
    });

    if (dangerouslyUseLabelsKey && !labelFound) {
      return key;
    }
    if (
      showKeysIfNotExistFlag &&
      !labelFound &&
      (typeof labelValue === 'undefined' || labelValue === null || labelValue === '')
    ) {
      if (!missingLabelKeys.find((item) => item.key === key)) {
        missingLabelKeys.push({ key, defaultValue });
      }
      return key;
    }
  }
  storeMissingLabelKeys();
  if (typeof labelValue !== 'undefined' && labelValue !== null) {
    return labelValue;
  }
  if (defaultValue) {
    return defaultValue;
  }
  return key;
};

const storeMissingLabelKeys = () => {
  if (typeof window !== 'undefined')
    {if (window.FR && window.FR.missingLabelKeys) {
      window.FR.missingLabelKeys = missingLabelKeys;
    } else {
      window.FR = { missingLabelKeys: [] };
    }}
};

export { getTranslations, translate };
